import { Wrench, Sparkles, Shield } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";

const services = [
  {
    icon: Sparkles,
    title: "Premium Car Detailing",
    desc: "Multi-stage paint correction, deep interior detailing, and mirror-gloss finishes that look better than showroom.",
    img: "https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg",
    tag: "01",
  },
  {
    icon: Shield,
    title: "Window Tinting",
    desc: "Precision tint installs for privacy, heat rejection, and a sleek finished look — done right the first time.",
    img: "https://images.unsplash.com/photo-1532578498858-e21a39e0a449",
    tag: "02",
  },
  {
    icon: Wrench,
    title: "Car Modification",
    desc: "Body kits, aggressive styling, spoilers, and performance aesthetics engineered to make a statement.",
    img: "https://images.unsplash.com/photo-1629019638491-c89d444bacaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxtb2RpZmllZCUyMG5lb24lMjBzcG9ydHMlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4Mjc5Mjc0M3ww&ixlib=rb-4.1.0&q=85",
    tag: "03",
  },
];

const ServiceCard = ({ s }) => {
  const ref = useReveal();
  const Icon = s.icon;
  return (
    <div
      ref={ref}
      data-testid={`specialty-card-${s.tag}`}
      className="reveal group bg-[#141414] border border-[#262626] hover:border-[#FF4500]/60 transition-all duration-300 hover:drop-shadow-[0_0_15px_rgba(255,69,0,0.2)] flex flex-col"
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={s.img}
          alt={s.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#141414] to-transparent" />
        <span className="absolute top-4 right-4 font-heading text-5xl font-bold text-white/10">{s.tag}</span>
      </div>
      <div className="p-8 flex-1 flex flex-col">
        <div className="w-12 h-12 flex items-center justify-center border border-[#FF4500] text-[#FF4500] mb-6">
          <Icon size={22} />
        </div>
        <h3 className="font-heading text-xl font-bold uppercase text-white tracking-tight">{s.title}</h3>
        <p className="mt-4 text-sm text-neutral-400 leading-relaxed">{s.desc}</p>
      </div>
    </div>
  );
};

export const Specialties = () => (
  <section id="specialties" data-testid="specialties-section" className="py-24 md:py-32 bg-[#0A0A0A]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex items-center gap-3 mb-6">
        <span className="h-px w-12 bg-[#FF4500]" />
        <span className="text-sm uppercase tracking-[0.3em] text-[#FF4500] font-semibold">What We Do</span>
      </div>
      <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight uppercase text-white max-w-2xl">
        Our Specialties
      </h2>
      <p className="mt-4 text-base md:text-lg text-neutral-400 max-w-xl">
        Three pillars. One obsession — making your car the loudest thing on the block without starting the engine.
      </p>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {services.map((s) => (
          <ServiceCard key={s.tag} s={s} />
        ))}
      </div>
    </div>
  </section>
);
